import { Origin } from "../../types/general-types";

export class SourceBook {
  private readonly __v = 1;
  private _id: string;
  source: string;
  accountId: string;
  origin: Origin;

  // todo remove the any
  constructor(sourceBookObj: any) {
    if (sourceBookObj == null) {
      return;
    }

    this._id = sourceBookObj._id ? sourceBookObj._id : crypto.randomUUID();
    this.source = sourceBookObj.source;
    this.accountId = sourceBookObj.accountId;
    this.origin = sourceBookObj.origin ? sourceBookObj.origin : Origin.manual;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }
}
